<div class="container-select">
  <div class="ggi-input">
    <ng-select
      [clearable]="false"
      [searchable]="false"
      [items]="items"
      bindLabel="label"
      bindValue="id"
      id="property"
      placeholder="Selecciona una propiedad"
      notFoundText="'No hay proyectos disponibles'"
      (change)="setDepartment($event)"
    >
    </ng-select>
  </div>
</div>

<div
  class="wrapper-selected-property"
  *ngIf="!typePropertySelected && items.length"
>
  <h4>¡Vamos!</h4>
  <p class="subtitule-2">Selecciona tu propiedad</p>
  <img src="/assets/img/icons/building.svg" alt="no-property" />
</div>

<div class="ggi-tab-container" *ngIf="items?.length">
  <div class="department-container" *ngIf="typePropertySelected">
    <div class="department-info">
      <p class="subtitule-bay-2 property-name">
        {{ typePropertySelected.label }}
      </p>
      <p class="subtitule-bay-2 surface">
        Superficie: {{ typePropertySelected.area }} M<sup>2</sup>
      </p>
      <div
        class="wrapper-property-selected"
        [ngClass]="{ 'two-columns': featuresCount > 9 }"
      >
        <p
          class="body-2 features"
          *ngFor="let feat of typePropertySelected.features"
        >
          {{ feat }}
        </p>

        <p class="body-2 features" *ngFor="let empty of emptyArray"></p>
      </div>
    </div>
    <div class="image-container">
      <img [src]="image" [alt]="typePropertySelected.label" />
    </div>
  </div>
</div>

<div class="wrapper-no-properties-available" *ngIf="!items.length">
  <p class="body-2">No hay propiedades disponibles</p>
</div>
